<template>
  <div>
    <v-row :justify="$vuetify.breakpoint.xs ? 'center' : 'end'">
      <v-col cols="auto" class="mt-2" @click="anexar" v-if="opcaoEditar">
        <icon name="paperclip" :size="20" style="cursor: pointer;" tooltip="Anexar Documento" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :class="$vuetify.breakpoint.xs ? '' : 'pb-0 pr-8 pl-4'">
        <component-loading :value="isLoadingTablePremiacoes" />
        <table-cadu
          v-if="!isLoadingTablePremiacoes"
          v-model="selected"
          custom
          nameTab="premiacoesMercado"
          :showCheck="opcaoEditar"
          :loading="isLoadingTablePremiacoes"
          :disabledAllButtons="!(verifyPermission() && isEditar())"
          :showFiltro="false"
          :disabledButtons="arrayBotoesPermitidos"
          :class="$vuetify.breakpoint.xs ? 'mandatos-mobile' : 'mandatos'"
          :append-icon="'$vuetify.icons.chevron-down'"
          :rows="rows"
          :rowsHeader="rowsHeader"
          :items="['05', '10', '15', '20']"
          :elementsPerPageProp="elementsPerPage"
          :pagina="pagina"
          :qtPaginas="qtPaginas"
          :qtResultados="qtResultados"
          :texto="addPremiacao()"
          @change-page="(page) => changePage(page.currentPage)"
          @change-element="(element) => changeSelect(element)"
          @clickButton="(edit) => clickButton(edit)"
          @ordena="(obj) => ordernaTable(obj)"
        >
        </table-cadu>
      </v-col>
    </v-row>

    <ExcluirModal
      :text="'Tem certeza que deseja excluir essa premiação?'"
      :showDelete="showDelete"
      @close="deleteModal"
      @confirmDelete="confirmDelete()"
    />

    <SucessoModal
      :genericMessage="messageANS"
      :showSucess="showSucess"
      :sucessType="typeSucess"
      @close="closeSuccess"
    />

    <ErrorModal v-model="error" :errObj="errObj" />

    <ModalPremiacaoMercado
      ref="modalPremiacaoMercado"
      v-model="showModalPremiacao"
      :value="showModalPremiacao"
      :premiacao="objPremiacao"
      :action="action"
      @salvar="(obj) => salvar(obj)"
      @finalizar-criar="(obj) => finalizarCriarOutro(obj)"
    />

    <overlay-loading v-model="loadingOverlay" />
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode'

import PremiacaoMercado from '../../../../services/Certificação/PremiacaoMercado/PremiacaoMercado'
import ModalPremiacaoMercado from './ModalPremiacaoMercado'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
import { EventBus } from '@/services/EventBus/EventBus'

export default {
  components: {
    ModalPremiacaoMercado,
    ErrorModal
  },

  data() {
    return {
      selected: [],
      selecedCheck: [],
      delSeletected: [],
      rows: [],
      rowsHeader: [
        { text: 'Nome da Premiação', icon: 'repeat' },
        { text: 'Instituição Responsável', icon: 'repeat' },
        { text: 'Data da Premiação', icon: 'repeat' }
      ],
      pagina: 1,
      qtPaginas: 1,
      qtResultados: 1,
      isLoading: true,
      isLoadingTablePremiacoes: false,
      elementsPerPage: 10,
      argsPadrao: `tamanhoPagina=${this.elementsPerPage}&pagina=1`,
      canAdd: true,
      arrayBotoesPermitidos: [false, true, true],
      ordenacao: 'nome',
      ordem: 'desc',

      role: '',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      loadingOverlay: false,

      showDelete: false,

      objPremiacao: {},
      showModalPremiacao: false,
      finalizarCriar: false,
      action: 'EDIT',

      // Sucesso Modal
      messageANS: '',
      showSucess: false,
      typeSucess: '',

      teste: [],

      // Error Modal
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role

    this.argsPadrao = `tamanhoPagina=${this.elementsPerPage}&pagina=1`
    this.permissaoBotoes()
    this.getPremiacoes(this.argsPadrao)
  },
  methods: {
    anexar() {
      EventBus.$emit('showAnexo', 'Certificações')
    },
    addPremiacao() {
      if (this.verifyPermission() && this.isEditar()) {
        return '+ adicionar nova premiação'
      } else {
        return ''
      }
    },

    isEditar() {
      return this.opcaoEditar === true
    },

    clickButton(obj) {
      let selected = obj.selected
      switch (obj.type) {
        case 'add':
          this.objPremiacao = this.emptyObject()
          this.action = obj.type
          this.showModalPremiacao = true
          this.messageANS = 'Premiação adicionada com sucesso!'
          break
        case 'edit':
          this.objPremiacao = this.rows[obj.index]
          this.action = obj.type
          this.showModalPremiacao = true
          this.messageANS = 'Premiação editada com sucesso!'
          break
        case 'view':
          this.objPremiacao = this.rows[obj.index]
          this.action = obj.type
          this.showModalPremiacao = true
          break
        case 'delete':
          this.delSeletected = []
          this.delSeletected.push(this.rows[obj.index].id)
          this.showDelete = true
          this.messageANS = 'Premiação excluida com sucesso!'
          break
        case 'delAll':
          this.delSeletected = []
          this.delSeletected = selected
          this.showDelete = true
          this.messageANS = 'Premiação excluida com sucesso!'
          break
      }
    },

    ordernaTable({ _, index }) {
      const ordenacoes = {
        0: 'nome',
        1: 'institutoResponsavel',
        2: 'dataPremiacao'
      }

      switch (index) {
        case 0:
        case 1:
        case 2:
          this.ordem = this.ordem === 'asc' ? 'desc' : 'asc'
          this.ordenacao = ordenacoes[index]
          break

        default:
          this.ordem = 'asc'
          this.ordenacao = 'nome'
          break
      }

      this.getPremiacoes(this.getArg())
    },

    changePage(pagina) {
      this.pagina = pagina
      let argumento = this.getArg()
      this.getPremiacoes(argumento)
    },

    changeSelect(elemento) {
      if (elemento.elementsPerPage !== this.rows.length && this.pagina < this.qtPaginas) {
        this.elementsPerPage = elemento
        let argumento = this.getArg()
        this.getPremiacoes(argumento)
      } else {
        this.pagina = 1
        this.elementsPerPage = elemento
        let argumento = this.getArg()
        this.getPremiacoes(argumento)
      }
    },

    permissaoBotoes() {
      if (this.verifyPermission() && this.isEditar()) {
        this.arrayBotoesPermitidos = [false, true, true]
      } else {
        this.arrayBotoesPermitidos = [false, false, false]
      }
    },

    verifyPermission() {
      if (this.role === 'admin_brasil' || this.role === 'admin' || this.role === 'dirigente') {
        return true
      } else {
        return false
      }
    },

    async getPremiacoes(args) {
      this.isLoadingTablePremiacoes = true

      const premiacao = new PremiacaoMercado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await premiacao
        .getPremiacao(args)
        .then((res) => {
          this.rows = res.data.conteudo
          this.qtPaginas = res.data.qtPaginas
          this.qtResultados = res.data.qtResultados
          this.pagina = res.data.pagina
        })
        .catch((err) => {
          console.error(err)

          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => {
          this.isLoadingTablePremiacoes = false
        })
    },

    async putPremiacao(obj) {
      this.loadingOverlay = true

      const premiacao = new PremiacaoMercado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await premiacao
        .putPremiacao(obj)
        .then(() => {
          this.showSucess = true
          this.showModalPremiacao = false
        })
        .catch((err) => {
          console.error(err)
          this.showModalPremiacao = false
          this.error = true
          this.showModalPremiacao = false
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.loadingOverlay = false))
    },

    async finalizarCriarOutro(obj) {
      await this.putPremiacao(obj)
      this.finalizarCriar = true
    },

    salvar(obj) {
      this.putPremiacao(obj)
    },

    async confirmDelete() {
      this.loadingOverlay = true

      const premiacao = new PremiacaoMercado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await premiacao
        .deletePremiacao(this.delSeletected)
        .then(() => {
          this.showSucess = true
          this.showDelete = false
        })
        .catch((err) => {
          console.error(err)

          this.showDelete = false
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
        .finally(() => (this.loadingOverlay = false))
    },

    async closeSuccess() {
      this.showSucess = false
      this.getPremiacoes(this.argsPadrao)
      if (this.finalizarCriar) {
        this.showModalPremiacao = true
        this.finalizarCriar = false
      }
    },

    deleteModal() {
      this.selected = []
      this.showDelete = false
    },

    getArg() {
      return `ordenacao=${this.ordenacao}&direcaoOrdenacao=${this.ordem}&tamanhoPagina=${this.elementsPerPage}&pagina=${this.pagina}`
    },

    emptyObject() {
      return {
        nome: '',
        institutoResponsavel: '',
        dataPremiacao: '',
        id: null
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.circle-status
    border-radius: 10px
    width: 9px
    height: 9px

.mandatos-mobile > .table-cadu
  padding: 20px 10px !important
  border: none
  border-radius: 0px
  width: 100% !important

.mandatos > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important

.mandatos > .table-cadu > .table > table
    width: 100% !important

.mandatos-mobile > .table-cadu > .table > table
    width: 100% !important
</style>
